import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import filterLinesIcon from 'assets/images/icons/filter-lines.svg';
import keyIcon from 'assets/images/icons/key.svg';
import submissionAttachmentIcon from 'assets/images/icons/submission-attachment.svg';
import SingleCheckBoxField from 'components/form-components/SingleCheckBoxField';

const TableHeader = ({
  tableFields,
  onSelection,
  mediaEnabled,
  isActionsEnabled,
  isSelectionEnabled,
  selectionValue,
  type,
  selectedColumns,
  onColumnSelection,
  cellBorder,
}) => {
  const { t } = useTranslation();
  const trCellBorderClass =
    cellBorder === 'horizontal' || cellBorder === 'both' ? 'cell-border-horizontal' : '';
  const thCellBorderClass =
    cellBorder === 'vertical' || cellBorder === 'both' ? 'cell-border-vertical' : '';

  return (
    <thead className={`${trCellBorderClass} ${thCellBorderClass}`}>
      <tr>
        {isSelectionEnabled && (
          <th className='table-checkbox'>
            <SingleCheckBoxField
              name={'all'}
              value={selectionValue}
              handleChange={onSelection}
              shrink
              classes=''
            />
          </th>
        )}
        {tableFields.map((singleHeaderField, index) => {
          return singleHeaderField.isSelected ? (
            <th key={index} className='nowrap'>
              <div
                className={`d-flex gap-2 align-items-center ${singleHeaderField.className ?? ''}`}
              >
                {type === 'data_sources_entries' && (
                  <SingleCheckBoxField
                    name={'column'}
                    value={
                      !!selectedColumns?.find((c) => c.columnId === singleHeaderField.columnId)
                    }
                    handleChange={() => onColumnSelection(singleHeaderField)}
                    classes='w-auto'
                    shrink
                  />
                )}
                {singleHeaderField.icon && (
                  <img className='column-icon' src={singleHeaderField.icon} />
                )}
                {t(singleHeaderField.displayName)}
                {singleHeaderField.isMediaAttached && mediaEnabled && (
                  <img className='ms-3' src={submissionAttachmentIcon} />
                )}
                {singleHeaderField.name === 'keyFilter' && <img src={keyIcon} />}
                {type === 'data_sources_entries' && singleHeaderField.isKeyFilter && (
                  <img src={keyIcon} />
                )}
                {type === 'data_sources_entries' && singleHeaderField.isFilter && (
                  <img src={filterLinesIcon} />
                )}
              </div>
            </th>
          ) : null;
        })}
        {isActionsEnabled && <th></th>}
      </tr>
    </thead>
  );
};

TableHeader.propTypes = {
  tableFields: PropTypes.array.isRequired,
  onSelection: PropTypes.func,
  mediaEnabled: PropTypes.bool,
  isSelectionEnabled: PropTypes.bool.isRequired,
  isActionsEnabled: PropTypes.bool.isRequired,
  selectionValue: PropTypes.bool.isRequired,
  type: PropTypes.string,
  selectedColumns: PropTypes.array,
  onColumnSelection: PropTypes.func,
  cellBorder: PropTypes.string,
};

export default TableHeader;
